<script>
	let email = '';
	let loading = false;
	let success = false;
	let error = '';

	async function handleReset(e) {
		e.preventDefault();
		loading = true;
		error = '';

		try {
			const response = await fetch('/api/auth/forgot-password', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ email })
			});

			if (response.ok) {
				success = true;
			} else {
				const data = await response.json();
				throw new Error(data.message || 'Something went wrong');
			}
		} catch (err) {
			error = err.message;
		} finally {
			loading = false;
		}
	}
</script>

<svelte:head>
	<title>Forgot Password - OS Studio</title>
	<meta name="description" content="Reset your OS Studio account password." />
</svelte:head>

<div class="min-h-screen bg-gradient-to-br from-purple-900 to-blue-900 flex items-center justify-center p-4">
	<div class="bg-white rounded-lg shadow-2xl w-full max-w-md p-8">
		<div class="text-center mb-8">
			<h1 class="text-3xl font-bold text-gray-900 mb-2">Reset Password</h1>
			<p class="text-gray-600">Enter your email to receive reset instructions</p>
		</div>

		{#if success}
			<div class="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg mb-6">
				Check your email for password reset instructions
			</div>
			<div class="text-center">
				<a href="/login" class="text-purple-600 hover:text-purple-700 font-semibold">Back to login</a>
			</div>
		{:else}
			<form on:submit={handleReset} class="space-y-4">
				{#if error}
					<div class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
						{error}
					</div>
				{/if}

				<div>
					<label for="email" class="block text-sm font-semibold text-gray-700 mb-2">
						Email Address
					</label>
					<input
						id="email"
						type="email"
						bind:value={email}
						placeholder="you@company.com"
						required
						class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-purple-600"
					/>
				</div>

				<button
					type="submit"
					disabled={loading}
					class="w-full px-4 py-3 bg-purple-600 text-white font-semibold rounded-lg hover:bg-purple-700 transition-colors disabled:opacity-50"
				>
					{loading ? 'Sending...' : 'Send Reset Link'}
				</button>
			</form>

			<div class="mt-6 text-center">
				<a href="/login" class="text-purple-600 hover:text-purple-700 font-semibold">Back to login</a>
			</div>
		{/if}
	</div>
</div>
